// extracted by mini-css-extract-plugin
module.exports = {"component":"TextInput_component__3K_wy","optional":"TextInput_optional__29_Qj","textInput":"TextInput_textInput__3Q7BI"};